import { H2 } from '@components/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 1rem 10rem 8rem 10rem;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    background-color: ${({ theme }) => theme.color.white};
    grid-template-columns: 1fr;
    padding: 2rem 0rem;
  }
`;

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    max-width: 420px;
    margin-top: 2rem;

    &:nth-child(2n) {
      background: #ffffff;
    }
  }
`;

export const ItemWrapper = styled.div`
  background-color: #ffffff;
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  justify-items: center;

  border: 3px solid ${({ theme }) => theme.color.greyLight};
  border-radius: 1rem;
  width: 840px;

  margin-top: 3rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    width: 700px;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
    margin-top: 8rem;
    width: 100%;
  }
`;

export const LeftWrapper = styled.div<{ color?: string }>`
  align-content: center;
  border-right: 0.5rem solid ${({ color, theme }) => color || theme.color.grey1};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-right: none;
  }
`;

export const RightWrapper = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-self: start;

  width: 100%;
  height: 100%;
  padding: 3rem 1rem 3rem 4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-top: 0.5rem solid ${({ color, theme }) => color || theme.color.grey1};

    margin-left: 2rem;
    margin-right: 2rem;
    padding: 2rem 0rem;

    width: auto;

    @supports (width: -webkit-fill-available) {
      width: -webkit-fill-available;
    }
  }
`;

export const ImageWrapper = styled.div`
  padding: 4rem 4rem;
  width: 300px;
  height: 300px;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: 2rem 2rem;
    height: auto;
    width: 100%;
  }
`;

export const EventLogoWrapper = styled.div`
  width: auto;
  height: 5rem;
`;

export const EventLogo = styled.img`
  position: absolute;
  top: 1rem;
  right: 1rem;

  height: 5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;

    width: 105px;
    height: 35px;

    top: -40px;
    right: 0px;
  }
`;

export const LogoImage = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
`;

export const ItemTitle = styled(H2)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size18};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height125};

  margin-bottom: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
    line-height: ${({ theme }) => theme.lineHeight.height115};
  }
`;

export const ItemAbout = styled.div`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size18};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height135};
  margin-bottom: 2rem;

  display: -webkit-box;
  overflow: hidden;

  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;

  div {
    p {
      font-weight: ${({ theme }) => theme.fontWeight.weight400};

      strong {
        font-weight: ${({ theme }) => theme.fontWeight.weight400};
      }

      a {
        color: ${({ theme }) => theme.color.mobilityGrey};
        font-size: ${({ theme }) => theme.fontSize.size18};
      }
    }
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ theme }) => theme.fontSize.size16};
  }
`;

export const Badge = styled.span<{ color?: string }>`
  background-color: ${({ color, theme }) => color || theme.color.mobilityGrey};
  color: ${({ theme }) => theme.color.white} !important;

  position: absolute;
  left: 60px;
  top: -20px;

  padding: 0.8rem 2rem;

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width768}) {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    font-size: ${({ theme }) => theme.fontSize.size14};

    left: 0px;
    top: -40px;
`;

export const CategoryTitle = styled(H2)`
  color: ${({ color, theme }) => color || theme.color.black};
  font-size: ${({ theme }) => theme.fontSize.size32};
  text-align: center;

  margin-top: 4rem;
  width: 100%;
`;

export const DividerWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
